/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Below_FloorInputs */



/**
* | output |
* | --- |
* | "Not allowed in your organization" |
*
* @param {Agent_Builder_Confirmation_Below_FloorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_below_floor = /** @type {((inputs?: Agent_Builder_Confirmation_Below_FloorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Below_FloorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In Ihrer Organisation nicht erlaubt")
	return /** @type {LocalizedString} */ ("Not allowed in your organization")
});